import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import ExerciesSearchBlock from './ExerciesSearchBlock';
import { getExercies } from '../../../ducks/workoutActions';


const ExerciesList = props => {
  let { exerciesNum, values, setFieldValue } = props;

  //component did mount
  useEffect(() => {
    props.getExercies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="exercies-list">
      {
        exerciesNum && [...Array(~~exerciesNum).keys()].map(index => {
          return(
            <ExerciesSearchBlock index={index} key={`ExerciesSearchBlock${index}`} values={values} setFieldValue={setFieldValue}/>
          );
        })
      }
    </div>
  );
};

function mapDispatchToProps(dispatch) {
  return {
    getExercies: () => dispatch(getExercies())
  };
}

export default connect(
  null,
  mapDispatchToProps
)(ExerciesList);
